import { ListBoxChangeEvent } from "primereact/listbox";
import { useState } from "react";
import CategoryAPIDataSourceImpl from "../../Data/DataSource/API/CategoryAPIDataSource";
import { CategoryRepositoryImpl } from "../../Data/Repository/CategoryRepositoryImpl";
import { Category } from "../../Domain/Model/Category";
import { CreateCategory } from "../../Domain/UseCase/CreateCategory";
import { GetCategories } from "../../Domain/UseCase/GetCategories";
import { RemoveCategory } from "../../Domain/UseCase/RemoveCategory";
import { UpdateCategory } from "../../Domain/UseCase/UpdateCategory";


export default function CategoryViewModel() {

    const [categories, setCategories] = useState<Category[]>([]);

    const categoryDataSourceImpl = new CategoryAPIDataSourceImpl();
    const categoryRepositoryImpl = new CategoryRepositoryImpl(categoryDataSourceImpl);

    const getCategoriesUseCase = new GetCategories(categoryRepositoryImpl);
    const createCategoryUseCase = new CreateCategory(categoryRepositoryImpl);

    const removeCategoryUseCase = new RemoveCategory(categoryRepositoryImpl);
    const updateCategoryUseCase = new UpdateCategory(categoryRepositoryImpl)


     async function getCategories() {
        setCategories( await getCategoriesUseCase.invoke());
      }

      // function _resetValue() {
      //   setValue("");
      // }

      async function createCategory(data: Category) {
        try {
          const createdCategory = await createCategoryUseCase.invoke(data);
          if(createdCategory){
            console.log("enviado");
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }

      async function removeCategory(id: string) {
        try {
          let removedCategory = await removeCategoryUseCase.invoke(id);
          if(removedCategory){
            console.log("eliminado");
           return removedCategory;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }

      async function updateCategory(data: Category) {
        try {
          let updatedCategory = await updateCategoryUseCase.invoke(data);
          if(updatedCategory){
            console.log("Actualizado");
           return updatedCategory;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }



      function onChangeCategory(e: ListBoxChangeEvent) {
        e.preventDefault();
        setCategories(e.target.value);
      }
      
      return {
        getCategories,
        createCategory,
        removeCategory,
        updateCategory,
        onChangeCategory,
        categories,
      };
}